import {
  Detail,
  DetailAction,
  DetailAttribute,
  DetailsChartsDto,
  DocumentPermission,
  PtEntity,
  UiDocumentItem,
  UiDocumentType
} from '@pt/pt-models';
import { HeaderDetails } from '@pt/pt-core';
import { Validated } from 'it/primatoo/openapi/api/org/schemas/common/docs/_findallvalidateddocresponse/Validated';
import { BusinessProjectManagementService } from '@pt/api-client';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  GetTreatmentForDetailsResponse
} from 'it/primatoo/openapi/api/org/schemas/treatment/GetTreatmentForDetailsResponse';
import { AvailableOperations } from 'it/primatoo/openapi/api/org/schemas/common/AvailableOperations';
import {
  FindAllValidatedDocResponse
} from 'it/primatoo/openapi/api/org/schemas/common/docs/FindAllValidatedDocResponse';
import { AbstractValidatedDocumentDetailPage } from './abstract-validated-document-detail-page';
import { TranslateService } from '@ngx-translate/core';
import { DetailsPageError, ReminderPayload } from '../components/details';
import { WidgetDialogService } from '../documents';
import { DialogService } from '../services';

export abstract class AbstractTreatmentDocumentDetailPage extends AbstractValidatedDocumentDetailPage {
  public validated: Array<Validated> = [];
  public details: Detail[];
  public currentDetails: GetTreatmentForDetailsResponse;
  public detailsPageLoading: boolean;
  public errorOccurred: DetailsPageError;
  public permission?: DocumentPermission;
  public treatmentRiskFactors: DetailsChartsDto[] = [];
  public reminderPayload?: ReminderPayload;


  public abstract getDocumentItem(): UiDocumentItem | undefined;

  public abstract getHeaderDetails(): HeaderDetails | undefined;

  public abstract getEntity(): PtEntity;

  public abstract getDocType(): UiDocumentType;

  protected abstract getActions(availableOperations: AvailableOperations): DetailAction[];

  protected abstract getAttributesDetails(details: unknown): DetailAttribute[]

  constructor(public service: BusinessProjectManagementService,
              public widgetDialogService: WidgetDialogService,
              public translateService: TranslateService,
              public dialogService: DialogService) {
    super(service, widgetDialogService, translateService, dialogService)
  }

  public loadDetails(id: number): void {
    this.errorOccurred = new DetailsPageError();
    if (id != null && id >= 0) {
      this.detailsPageLoading = true;
      this.currentDetails = undefined;
      forkJoin({
        details: this.service.getDetails(id),
        operations: this.service.getDocUserPermission(id),
        validated: this.service.getDocumentValidated(id)
      }).pipe(
        catchError(error => {
          this.errorOccurred.setError(error, this.getEntity());
          this.detailsPageLoading = false;
          return of(error)
        })).subscribe(
        (responses: {
          details: GetTreatmentForDetailsResponse,
          operations: AvailableOperations,
          validated: FindAllValidatedDocResponse
        }) => {
          if (responses.validated) {
            this.validated = responses.validated.validatedList;
          } else {
            this.validated = [];
          }
          if (responses.details && responses.operations) {
            this.currentDetails = responses.details;
            this.details = [{
              label: of(responses.details.name),
              body: {
                attributes: this.getAttributesDetails(responses.details),
                actions: this.getActions(responses.operations)
              }
            }];
          }

          this.reminderPayload = this.getReminderPayload();
          this.detailsPageLoading = false;
        }
      );
    } else {
      this.errorOccurred.setAsNotFound(this.getEntity());
    }
  }

  public getReminderPayload(): ReminderPayload {
    if (this.currentDetails && this.permission) {
      const response: ReminderPayload = {
        docType: this.getDocType(),
        docId: this.currentDetails?.docId,
        docName: this.currentDetails?.name,
        notification: this.currentDetails?.notification,
        enabled: this.permission.reminderBtnEnabled,
        visible: this.permission.reminderBtnVisible
      }
      return response
    }
    return null;
  }
}
